import "./styles.css";
import { initVipCheckout } from "./vip-checkout.js";

const menuButton = document.querySelector("[data-menu-button]");
const mobileMenu = document.querySelector("[data-mobile-menu]");
const mainContent = document.querySelector("main");
const mobileActionBar = document.querySelector(".mobile-action-bar");

function isolateFromMenu(element, isolated) {
  element.inert = isolated;
  element.toggleAttribute("inert", isolated);
  if (isolated) element.setAttribute("aria-hidden", "true");
  else element.removeAttribute("aria-hidden");
}

function setMenu(open) {
  menuButton.setAttribute("aria-expanded", String(open));
  mobileMenu.setAttribute("aria-hidden", String(!open));
  mobileMenu.inert = !open;
  mobileMenu.dataset.open = String(open);
  document.documentElement.classList.toggle("menu-open", open);
  document.body.classList.toggle("menu-open", open);
  isolateFromMenu(mainContent, open);
  isolateFromMenu(mobileActionBar, open);
  if (open) mobileMenu.scrollTop = 0;
}

menuButton.addEventListener("click", () => {
  setMenu(menuButton.getAttribute("aria-expanded") !== "true");
});

mobileMenu.addEventListener("click", (event) => {
  if (event.target.closest("a")) setMenu(false);
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    setMenu(false);
    menuButton.focus();
  }
});

window.addEventListener("resize", () => {
  if (window.innerWidth >= 860) setMenu(false);
});

document.querySelectorAll("img[data-location-image]").forEach((image) => {
  image.addEventListener("error", () => {
    image.hidden = true;
    image.parentElement.classList.add("location-photo--error");
    image.parentElement.setAttribute("data-error", "Location photo unavailable");
  });
});

const revealItems = document.querySelectorAll("[data-reveal]");
if ("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.dataset.visible = "true";
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: "0px 0px -8%", threshold: 0.12 });
  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => { item.dataset.visible = "true"; });
}

if (window.location.hash) {
  const pageLoaded = document.readyState === "complete"
    ? Promise.resolve()
    : new Promise((resolve) => window.addEventListener("load", resolve, { once: true }));
  const fontsLoaded = document.fonts?.ready ?? Promise.resolve();

  Promise.all([pageLoaded, fontsLoaded]).then(() => {
    const targetId = decodeURIComponent(window.location.hash.slice(1));
    const target = document.getElementById(targetId);
    if (target) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        target.scrollIntoView({ block: "start", behavior: "instant" });
      }));
    }
  });
}

initVipCheckout();
